module.exports = __webpack_public_path__ + "img/o5.87892195.png";